export const CertifiedPreOwned = {
    template: `<div class="w-full flex mt-2 justify-center items-center">
    <img :src="image" class="h-auto" alt="Certified Pre-Owned">
    </div>`,
    props: [
        'image',
    ],
}